import { api, tr } from './shared';

export function getAmocrmSections(lang) {
  const base = `${api.appHost}/integrations/amocrm-client`;
  return [
    {
      id: 'amocrm-overview',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'amoCRM',
      navGroupOrder: 45,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор', 'Overview'),
      title: tr(lang, 'amoCRM connector — обзор', 'amoCRM connector — overview'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Коннектор amoCRM клиента синхронизирует сделки/лиды с картами Loyalclub: установка wallet, начисление, списание (redeem) и writeback в amo. Хост: app.loyalclub.ru (не api.loyalclub.ru). Не используйте /amocrm/oauth — это другой контур.',
            'The client amoCRM connector syncs deals/leads with Loyalclub cards: wallet install, accrual, redeem and writeback into amo. Host: app.loyalclub.ru (not api.loyalclub.ru). Do not use /amocrm/oauth — that is a different contour.',
          ),
        },
        { type: 'list', title: 'Base URL', items: [base] },
        {
          type: 'list',
          title: tr(lang, 'Авторизация', 'Authorization'),
          items: [
            tr(lang, 'Management: Authorization: Bearer <USER_TOKEN>', 'Management: Authorization: Bearer <USER_TOKEN>'),
            tr(lang, 'Public webhook: секрет в URL, JWT не нужен', 'Public webhook: secret in URL, no JWT'),
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Сценарии операций', 'Operation scenarios'),
          items: ['accrual', 'redeem', 'sync_card', 'card_install_sync', 'manual_review'],
        },
      ],
    },
    {
      id: 'amocrm-connector-crud',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'amoCRM',
      navGroupOrder: 45,
      navSubgroup: tr(lang, 'Коннектор', 'Connector'),
      navSubgroupOrder: 10,
      navOrder: 10,
      navLabel: tr(lang, 'CRUD коннектора', 'Connector CRUD'),
      title: 'POST|GET|PATCH /organizations/{org_id}/connectors',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Создание возвращает webhook_secret один раз. Поля: subdomain, oauth_client_id/secret, card_id|card_uuid, mode: test|prod.',
            'Create returns webhook_secret once. Fields: subdomain, oauth_client_id/secret, card_id|card_uuid, mode: test|prod.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Методы', 'Methods'),
          items: [
            `POST ${base}/organizations/{org_id}/connectors`,
            `GET ${base}/organizations/{org_id}/connectors[/{uuid}]`,
            `PATCH ${base}/organizations/{org_id}/connectors/{uuid}`,
            `POST .../deactivate`,
            `DELETE .../connectors/{uuid}`,
            `POST .../webhook-secret/rotate`,
          ],
        },
        {
          type: 'code',
          title: 'curl create',
          key: 'amocrm-create',
          value: `curl -X POST "${base}/organizations/<ORG_ID>/connectors" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -H "Content-Type: application/json" \\\n  -d '{"subdomain":"mycompany","oauth_client_id":"...","oauth_client_secret":"...","card_uuid":"<CARD_UUID>","mode":"test"}'`,
        },
      ],
    },
    {
      id: 'amocrm-oauth',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'amoCRM',
      navGroupOrder: 45,
      navSubgroup: tr(lang, 'OAuth', 'OAuth'),
      navSubgroupOrder: 20,
      navOrder: 10,
      navLabel: tr(lang, 'OAuth start / callback', 'OAuth start / callback'),
      title: 'POST .../oauth/start · GET /oauth/callback',
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Flow', 'Flow'),
          items: [
            tr(lang, '1. POST .../oauth/start → authorization_url + state', '1. POST .../oauth/start → authorization_url + state'),
            tr(lang, '2. Пользователь авторизуется в amoCRM', '2. User authorizes in amoCRM'),
            tr(lang, '3. GET /integrations/amocrm-client/oauth/callback?code&state', '3. GET /integrations/amocrm-client/oauth/callback?code&state'),
            'GET .../oauth/status · POST .../oauth/refresh',
          ],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'redirect_after в start допускается только как относительный путь.',
            'redirect_after in start is allowed only as a relative path.',
          ),
        },
      ],
    },
    {
      id: 'amocrm-mapping-activate',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'amoCRM',
      navGroupOrder: 45,
      navSubgroup: tr(lang, 'Маппинг', 'Mapping'),
      navSubgroupOrder: 30,
      navOrder: 10,
      navLabel: tr(lang, 'Structure / mapping / activate', 'Structure / mapping / activate'),
      title: 'structure · mapping · activate',
      blocks: [
        {
          type: 'list',
          title: tr(lang, 'Подготовка', 'Setup'),
          items: [
            'POST .../structure/refresh',
            'POST .../schema/provision',
            'GET .../structure',
            'GET|PUT|POST .../mapping[/options|/suggest|/validate]',
            'POST .../activate',
          ],
        },
        {
          type: 'list',
          title: tr(lang, 'Features в mapping', 'Mapping features'),
          items: ['sync_card', 'card_link', 'card_install_sync', 'accrual', 'redeem', tr(lang, 'writeback-флаги', 'writeback flags')],
        },
      ],
    },
    {
      id: 'amocrm-webhook',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: 'amoCRM',
      navGroupOrder: 45,
      navSubgroup: tr(lang, 'Webhook', 'Webhook'),
      navSubgroupOrder: 40,
      navOrder: 10,
      navLabel: 'POST /webhook/.../leads',
      title: 'POST /webhook/{connector_uuid}/{webhook_secret}/leads',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Публичный webhook от amo. Ответ 202 + receipt. Лимит тела 1MB, ~120 req/min. Финансовые операции блокируются, пока wallet_installed не подтверждён.',
            'Public webhook from amo. Response 202 + receipt. Body limit 1MB, ~120 req/min. Financial ops are blocked until wallet_installed is confirmed.',
          ),
        },
        {
          type: 'code',
          title: 'URL',
          key: 'amocrm-webhook-url',
          value: `${base}/webhook/<CONNECTOR_UUID>/<WEBHOOK_SECRET>/leads`,
        },
        {
          type: 'list',
          title: tr(lang, 'Receipt status', 'Receipt status'),
          items: ['accepted', 'processed', 'ignored_duplicate', 'rejected'],
        },
        {
          type: 'list',
          title: tr(lang, 'Диагностика', 'Diagnostics'),
          items: [
            'GET .../operations[/{op_uuid}]',
            'GET .../webhook-events',
            'POST .../diagnostics/simulate-webhook',
            'POST .../diagnostics/dry-run',
            'POST .../operations/{uuid}/retry|reconcile|manual-review',
          ],
        },
      ],
    },
  ];
}
